<template>
  <section class="products" v-if="newProducts && newProducts.length">
    <div class="h2">{{ $t('newProducts') }}</div>
    <div class="col-md-12" style="margin-bottom: 20px; padding: 0px">
      <ul
        :class="`products seasidetms_products col-md-12 columns-${
          $mq.xtablet ? 6 : 3
        } new-products`"
      >
        <product-tile
          v-for="(product, index) in newProducts"
          :key="product.slug"
          :product="product"
          :detailsEnabled="false"
          :index="index"
        />
      </ul>
    </div>
  </section>
</template>

<script>
import ProductTile from '@/components/product/ProductTile'
import { mapState } from 'vuex'

export default {
  name: 'NewProducts',
  components: { ProductTile },
  computed: {
    ...mapState(['newProducts']),
  },
}
</script>

<style>
@media only screen and (min-width: 600px) {
  .new-products .seasidetms_product_header a {
    font-size: 12px;
    line-height: 1.2;
  }
}
.new-products .seasidetms_product_img .payParts:after {
  display: none;
}
.new-products .seasidetms_product_info .price {
  flex-direction: column;
}
.new-products .seasidetms_product_info .amount {
  margin-right: 0;
}
</style>
